import store from '@/store'

/**
 * 操作日志记录器
 */
class Logger {
  /**
   * 记录操作日志
   * @param {Object} logData 日志数据
   * @param {string} logData.action_type 操作类型 (user, house, favorite, banner, config, auth)
   * @param {string} logData.action_description 操作描述
   * @param {string} logData.target_type 操作目标类型
   * @param {number} logData.target_id 操作目标ID
   * @param {string} logData.target_title 操作目标标题
   * @param {Object} logData.request_data 请求数据
   * @param {Object} logData.response_data 响应数据
   */
  static async record(logData) {
    try {
      const adminInfo = store.getters.adminInfo
      const logEntry = {
        admin_id: adminInfo?.id || 1,
        admin_name: adminInfo?.nickname || '系统管理员',
        action_type: logData.action_type,
        action_description: logData.action_description,
        target_type: logData.target_type || null,
        target_id: logData.target_id || null,
        target_title: logData.target_title || null,
        ip_address: this.getClientIP(),
        user_agent: navigator.userAgent,
        request_data: logData.request_data || null,
        response_data: logData.response_data || null
      }

      // 在生产环境中，这里应该调用真实的API
      // await recordLog(logEntry)
      
      // 开发环境下，输出到控制台
      if (process.env.NODE_ENV === 'development') {
        console.log('操作日志记录:', logEntry)
      }
    } catch (error) {
      console.error('记录操作日志失败:', error)
    }
  }

  /**
   * 获取客户端IP地址（简化版本）
   */
  static getClientIP() {
    // 在实际应用中，IP地址应该由后端获取
    return '192.168.1.100'
  }

  /**
   * 记录用户管理操作
   */
  static recordUserAction(action, user, requestData = null, responseData = null) {
    this.record({
      action_type: 'user',
      action_description: `${action}用户：${user.nickname || user.real_name || user.id}`,
      target_type: 'user',
      target_id: user.id,
      target_title: user.nickname || user.real_name,
      request_data: requestData,
      response_data: responseData
    })
  }

  /**
   * 记录房源管理操作
   */
  static recordHouseAction(action, house, requestData = null, responseData = null) {
    this.record({
      action_type: 'house',
      action_description: `${action}房源：${house.title || house.id}`,
      target_type: 'house',
      target_id: house.id,
      target_title: house.title,
      request_data: requestData,
      response_data: responseData
    })
  }

  /**
   * 记录收藏管理操作
   */
  static recordFavoriteAction(action, data, requestData = null, responseData = null) {
    this.record({
      action_type: 'favorite',
      action_description: `${action}收藏记录`,
      target_type: 'favorite',
      target_id: data.id || null,
      target_title: data.title || '批量操作',
      request_data: requestData,
      response_data: responseData
    })
  }

  /**
   * 记录轮播图管理操作
   */
  static recordBannerAction(action, banner, requestData = null, responseData = null) {
    this.record({
      action_type: 'banner',
      action_description: `${action}轮播图：${banner.title || banner.id}`,
      target_type: 'banner',
      target_id: banner.id,
      target_title: banner.title,
      request_data: requestData,
      response_data: responseData
    })
  }

  /**
   * 记录系统配置操作
   */
  static recordConfigAction(action, config, requestData = null, responseData = null) {
    this.record({
      action_type: 'config',
      action_description: `${action}系统配置：${config.config_key || config.id}`,
      target_type: 'config',
      target_id: config.id,
      target_title: config.config_key,
      request_data: requestData,
      response_data: responseData
    })
  }

  /**
   * 记录认证操作
   */
  static recordAuthAction(action, requestData = null, responseData = null) {
    this.record({
      action_type: 'auth',
      action_description: `管理员${action}`,
      target_type: null,
      target_id: null,
      target_title: null,
      request_data: requestData,
      response_data: responseData
    })
  }
}

export default Logger